import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../modules';
import { setMenuID } from '../../../modules/tabMenu';
import AIRecommend from '../../../components/search/tabAIRecommend';
import {
  getPathNetworkRecommendAsync,
  GET_PATH_NETWORK_RECOMMEND_INFO,
  setIsMoreInfoPath0,
  setIsMoreInfoPath1,
  setIsMoreInfoPath2,
  tabAIState,
  getPathNetworkRecommend2Async,
  setIsMoreInfoPathAttach0,
  setIsMoreInfoPathAttach1,
  setIsMoreInfoPathAttach2,
} from '../../../modules/tabAI';

import { searchKeywordState } from '../../../modules/searchKeyword';
import { GetPathNetworkRecommendParamType2 } from '../../../lib/tabAI/recommendType';
import { PostConsumptionBodyType } from '../../../lib/common/type';
import { postConsumptionAsync } from '../../../modules/common';

function AIRecommendContainer() {
  const { searchKeyword } = useSelector(
    (state: RootState) => state.searchKeyword
  );
  const {
    network_data,
    recommend_path,
    total_counts,
    result,
    patentData,
    recommendedWord,
    isMoreInfoPath0,
    isMoreInfoPath1,
    isMoreInfoPath2,
    isMoreInfoPathAttach0,
    isMoreInfoPathAttach1,
    isMoreInfoPathAttach2,
    crawler_data_ai_network_data,
    crawler_data_ai_recommend_path,
    crawler_data_ai_results,
    crawler_data_ai_total_counts,
    loading,
  } = useSelector((state: RootState) => state.tabAI);
  const dispatch = useDispatch();

  const onPostConsumption = (info: PostConsumptionBodyType) => {
    dispatch(postConsumptionAsync.request(info));
  };

  const onSetMenuID = (selectedMenuId: number) => {
    dispatch(setMenuID(selectedMenuId));
  };

  const onGetPathNetwork = (info: GET_PATH_NETWORK_RECOMMEND_INFO) => {
    dispatch(getPathNetworkRecommendAsync.request(info));
  };
  const onGetPathNetwork2 = (info: GetPathNetworkRecommendParamType2) => {
    dispatch(getPathNetworkRecommend2Async.request(info));
  };

  const onSetIsMoreInfoPath0 = (
    isMoreInfoPath0: tabAIState['isMoreInfoPath0']
  ) => {
    dispatch(setIsMoreInfoPath0(isMoreInfoPath0));
  };
  const onSetIsMoreInfoPath1 = (
    isMoreInfoPath1: tabAIState['isMoreInfoPath1']
  ) => {
    dispatch(setIsMoreInfoPath1(isMoreInfoPath1));
  };
  const onSetIsMoreInfoPath2 = (
    isMoreInfoPath2: tabAIState['isMoreInfoPath2']
  ) => {
    dispatch(setIsMoreInfoPath2(isMoreInfoPath2));
  };
  const onSetIsMoreInfoPathAttach0 = (
    isMoreInfoPathAttach0: tabAIState['isMoreInfoPathAttach0']
  ) => {
    dispatch(setIsMoreInfoPathAttach0(isMoreInfoPathAttach0));
  };
  const onSetIsMoreInfoPathAttach1 = (
    isMoreInfoPathAttach1: tabAIState['isMoreInfoPathAttach1']
  ) => {
    dispatch(setIsMoreInfoPathAttach1(isMoreInfoPathAttach1));
  };
  const onSetIsMoreInfoPathAttach2 = (
    isMoreInfoPathAttach2: tabAIState['isMoreInfoPathAttach2']
  ) => {
    dispatch(setIsMoreInfoPathAttach2(isMoreInfoPathAttach2));
  };

  return (
    <AIRecommend
      onGetPathNetwork2={onGetPathNetwork2}
      onSetMenuID={onSetMenuID}
      onSetIsMoreInfoPath0={onSetIsMoreInfoPath0}
      onSetIsMoreInfoPath1={onSetIsMoreInfoPath1}
      onSetIsMoreInfoPath2={onSetIsMoreInfoPath2}
      onSetIsMoreInfoPathAttach0={onSetIsMoreInfoPathAttach0}
      onSetIsMoreInfoPathAttach1={onSetIsMoreInfoPathAttach1}
      onSetIsMoreInfoPathAttach2={onSetIsMoreInfoPathAttach2}
      onPostConsumption={onPostConsumption}
      loading={loading}
      patentData={patentData}
      recommendedWord={recommendedWord}
      isMoreInfoPath0={isMoreInfoPath0}
      isMoreInfoPath1={isMoreInfoPath1}
      isMoreInfoPath2={isMoreInfoPath2}
      isMoreInfoPathAttach0={isMoreInfoPathAttach0}
      isMoreInfoPathAttach1={isMoreInfoPathAttach1}
      isMoreInfoPathAttach2={isMoreInfoPathAttach2}
      crawler_data_ai_network_data={crawler_data_ai_network_data}
      crawler_data_ai_recommend_path={crawler_data_ai_recommend_path}
      crawler_data_ai_results={crawler_data_ai_results}
      crawler_data_ai_total_counts={crawler_data_ai_total_counts}
    />
  );
}

export default AIRecommendContainer;
